import React,{useEffect,useState} from 'react';
// import "./styles.css";
import { useSelector } from 'react-redux';
import SectionHeader from '../../../Molecules/SectionHeader';
import { Styles } from './styles';

const SupportedBrowsers = () => {
  const { currentLanguage } = useSelector((storeState) => storeState.language);
  const [content, setContent] = useState({});
  useEffect(() => {
    import(`./Content/${currentLanguage}.json`)
      .then(module => setContent(module.default))
      .catch(error => console.error("Failed to load content:", error));
  }, [currentLanguage]);
  let titleClassName = content?.staticPages?.titleClassName;
  let wrapperClassName = content?.staticPages?.wrapperClassName;
  let subTitleClassName = content?.staticPages?.subTitleClassName;
  let supportedClassName = content?.staticPages?.supportedClassName;
  let enClassName = content?.staticPages?.enClassName;

  let handleClose = () => {
    window.close();
  };
 
  return (
    <React.Fragment>
      <Styles />
        <div className='container-fluid  '>
          <div className='row '>
            <div className='col-12 ' >
              <div className='row  '>
                <div className='col-11 px-0 '>
                  <SectionHeader title="Supported Browsers"  current="Supported Browsers" />
                </div>
                <div className='col-1 btnClass border-bottom d-flex justify-content-end align-items-center' >
                  <button 
                    type="button" 
                    aria-label="Close" 
                    onClick={()=>handleClose()}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      fontSize: '2rem',
                      lineHeight: '1',
                      color: '#000',
                      cursor: 'pointer',
                      padding: '0.5rem',
                      fontWeight: '300'
                    }}
                  >
                    &times;
                  </button>
                </div>
              </div>
            </div>
          <div className={`col-12 px-3 px-md-5  px-lg-5 ${supportedClassName}`}>
          </div>
          <div className={` col-12 px-3 px-md-5  px-lg-5 ${wrapperClassName} `}>
            <div className='row ' >
              {content && content?.staticPages?.supportedBrowsers?.en?.map((element) => {
                return (
                  <div key={element.id} className={`col-12 ${enClassName} `}>
                      {element?.title &&
                        <div className={`row ${titleClassName} `}>
                          <div className='col-12 py-2'>
                            {element.title} 
                          </div>
                        </div>
                      }
                        {element?.subTitle && 
                          <div className={`row ${subTitleClassName} `}>
                            <div className='col-12 py-1'>
                              {element.subTitle}
                            </div>
                          </div>
                        }

                        {element?.subContent && element.subContent.map((sContent) => {
                          return (
                            <div className='row py-1' key={sContent.id}>
                              <div className='col-12'>
                                <span className='me-2'>•</span>
                                <span>{sContent.content}</span>
                              </div>
                            </div>
                          )
                        })}
                        {element?.ques && element.ques.map((q) => {
                          return (
                            <div className='row py-2' key={q.id}>
                              <div className='col-12'>
                                <strong> {q.qcontent} </strong>
                              </div>
                              <div className='col-12'>
                                {q.acontent}
                              </div>
                            </div>
                          )
                        })}
                        {element?.secondContent && 
                          <div className='row'>
                            <div className='col-12 py-2'>
                              {element.secondContent}
                            </div>
                          </div>
                        }
                        {element?.secondSubContent && element.secondSubContent.map((secSubContent) => {
                            return (
                              <div className='row py-1' key={secSubContent.id}>
                                <div className='col-12'>
                                  <span className='me-2'>•</span>
                                  <span>{secSubContent.content}</span>
                                </div>
                              </div>
                            )
                        })}
                        {element?.secTitle && 
                          <div className='row py-2'>
                            <div className='col-12'>
                              <strong>{element.secTitle}</strong>
                            </div>
                          </div>
                        }
                        {element?.thirdSubContent && element.thirdSubContent.map((third) => {
                          return (
                            <div className='row py-1' key={third.id}>
                              <div className='col-12'>
                                <span className='me-2'>•</span>
                                <span>{third.content}</span>
                              </div>
                            </div>
                          )
                        })}
                        {element?.fourthContent && 
                          <div className='row'>
                            <div className='col-12 py-2'>
                              {element.fourthContent}
                            </div>
                          </div>
                        }
                  </div>
                  );
                })}
              </div>
            </div>
          
      </div>
      </div>
    </React.Fragment>
  );
};

export default SupportedBrowsers;